<template>
  <div class="layout-inner">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">

        <template v-if="programGuide && programGuide.title">
          <program-guide-title :program-guide="programGuide"></program-guide-title>
        </template>

        <template v-if="isLoading">
          <div class="w-100 h-100 d-flex justify-content-center align-items-center">
            <spinner size="large"></spinner>
          </div>
        </template>
        <template v-else>
          <div class="container-fluid flex-grow-1 pg_content_container">
            <explore-insight-list :type="'insights'" :isAlumniInsights="'true'" v-if="!isLoading"></explore-insight-list>
          </div>
        </template>
        <program-footer-navbar :pageTitle="'Alumni Insights'" :returnTo="'programGuideMenu'" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import ProgramGuideTitle from './ProgramGuideTitle'
  import Navbar from '../../misc/components/./Navbar'
  import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
  import ExploreInsightList from '../../explore/components/ExploreInsightList'

  export default {
    name: 'program-guide-alumni-insights',
    props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
    components: {
      Navbar,
      ProgramGuideTitle,
      ProgramFooterNavbar,
      ExploreInsightList
    },
    data: () => {
      return {
        isLoading: true,
        programGuide: {}
      }
    },

    mounted () {
      this.loadDataForProgramGuideAlumniInsights()
    },

    methods: {
      ...mapActions([
        'loadProgramGuide',
        'setCurrentFacet'
      ]),
      async loadDataForProgramGuideAlumniInsights () {
        this.programGuide = await this.loadProgramGuide({
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type
        })
        this.setCurrentFacet('insights')
        this.isLoading = false
      },
      hideUserNamePopup () {
        this.$refs.userNamePopupContainer.$emit('close')
      }
    },
    computed: {
      ...mapState({
        'career': state => state.career.careerObject
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideAlumniInsights.vue